import React, { useState, useRef } from 'react';

//Importar dependencia para el dar formato de audio y video.
import ReactPlayer from 'react-player';
import Slider from '@mui/material/Slider';

//Importar helper para formatear el tiempo.
import { formatTime } from '../../../../../helpers/date';

//Iconos de Material UI.
import { Pause, PlayArrow, Mic } from '@mui/icons-material/';
import { IconButton } from '@mui/material';

// *******Componenete que renderiza un mensaje del tipo VIDEO o AUDIO********.

const NewAudioOrVideo = ({ entrante, messageHour, type, src }) => {

    const [playing, setPlaying] = useState(false); //Estado para controlar que se esté reproduciendo.
    const [progress, setProgress] = useState(0); // Estado para acualizar el progreso de reproducción.
    const [duration, setDuration] = useState(0); // Estado para actualizar el label con la duración.
    const player = useRef(null); // Referencia para el contenedor del archivo media.

     // Función para actualizar el progreso.
    const handleProgressChange = (event, newValue) => setProgress(newValue);

    const handleSeek = (event, newValue) => {
        const newProgress = parseFloat(newValue) / 100;
        setProgress(newValue);
        // Utiliza el método seekTo del ReactPlayer para cambiar la posición del video
        player.current.seekTo(newProgress);
    };

    const onProgressChange = (state) => {
        setProgress(state.played * 100); // Actualiza el progreso basado en el tiempo reproducido.
        setDuration(state.loadedSeconds); // Actualizar la duración total del archivo media
        if (state.played * 100 == 100) { // Si el progreso es igual a 100 (se terminó de reproducir el archivo media).
            setPlaying(false); // Setear el botón para que muestre de nuevo "Play".
        }
    };

    //Función para controlar la reproducción del archivo.
    const handlePlayChange = () => setPlaying(!playing);

    return (
        <div className="custom-player">
                 <div className={`container-slider-with-btn ${type === "audio" ? "audio" : "video"}  ${entrante ? "entrante" : "saliente"}`}>

                    {/*-----Detecta y renderiza el tipo de archivo media---------*/}
                    <div style={{ maxHeight: type === "video" ? '420px' : "",/*  width: '100%',  */overflow: 'hidden' }}>
                    <ReactPlayer
                        ref={player} // Referencia para ubicar el slider.
                        url={src}
                        controls={type === "video" ? true : false} // Oculta la barra de reproducción
                        width="200px" // Ajustar el ancho al contenedor
                        /* height="100%" */
                        playing={playing} // Propiedad para controlar la reproducción
                        className="react-player"
                        style={{ display: `${type === "audio" ? "none" : "block"}` }} // Si es audio, que oculte el display con el menú de control.
                        progressInterval={1} // Actualiza el progreso cada 1 ms = 0,001 s .
                        onProgress={(state) => onProgressChange(state)}
                    />
                </div>

                    {type === "audio" && <div className='group-row__layout'>
                        {/* Cambia el ícono del botón según el estado de reproducción */}
                        {playing
                            ? <IconButton onClick={handlePlayChange} > <Pause sx={{ fontSize: "35px" }} className={`btn-play-media ${entrante ? "entrante" : "saliente"}`} /></IconButton>
                            : <IconButton onClick={handlePlayChange} > <PlayArrow sx={{ fontSize: "35px" }} className={`btn-play-media ${entrante ? "entrante" : "saliente"}`} /> </IconButton>}
                        <div className='container-slider'>

                            {/*----------Slider de proseso-----------*/}
                            <Slider
                                value={progress}
                                onChangeCommitted={handleSeek} // Este evento se activa cuando se suelta el control del Slider
                                onChange={handleProgressChange}
                                aria-label="custom slider"
                                sx={{ // Estilos para la barra y el botón del slider.
                                    color: `${entrante ? "black" : "var(--btn-color)"}`, // Cambiar el color del slider a negro
                                    '& .MuiSlider-thumb': {
                                        backgroundColor: 'var(--bg-text-inbox-by-mode)', // Cambiar el color del thumb (control) a negro
                                        width: 12,
                                        height: 12,
                                    }
                                }}
                            />
                            {/*--------------Texto de la duración del archivo media--------------*/}
                            <div className={`content-text-progress  ${type === "audio" ? "audio" : "video"}`}>
                                {playing
                                    ? <span>{formatTime((progress / 100) * duration)} {/* / {formatTime(duration)} */}</span>
                                    : <span>{formatTime(duration)}</span>}
                               <Mic sx={{color: "var(--bg-text-inbox-by-mode)", fontSize: "17px" }} />

                            </div>

                        </div>

                    </div>}
                </div>
            

        </div>
    )
};

export default NewAudioOrVideo;